<template>
  <section
    class="section section-primary is-small animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <!-- Title -->
      <div class="content-wrapper animated preFadeInUp fadeInUp">
        <div class="section-title-wrapper has-text-centered mb-20">
          <div class="clean-bg-symbol">
            <i class="sl sl-icon-credit-card"></i>
          </div>
          <div>
            <h2
              class="clean-section-title has-text-white has-text-weight-bold is-paddingless"
            >
              خدمات (فيزا نت)
            </h2>
            <h3
              class="subtitle is-5 pt-10 pb-10 has-text-white has-text-weight-bold"
            >
              لطلبات إصدار بطاقة ، تغيير حالة بطاقتك (إيقاف/إلغاء) ، إعادة إصدار
              رقم سري،.
            </h3>
          </div>
        </div>
        <h2></h2>
        <div class="columns is-vcentered s">
          <div class="column">
            <div
              class="flex-card icon-card-hover visa-card light-bordered padding-20"
              @click="makeRequest(' إصدار بطاقة', 28)"
            >
              <h3 class="card-title has-text-link">إصدار بطاقة</h3>
              <p class="card-description">
                يمكنك التقدم بطلب الحصول على بطاقة فيزا الدولية ( بطاقة دفع
                مسبقا ) ، والتي يتم شحنها بالنقد الأجنبي بناء على طلبكم ، خصماً
                من حسابكم بالنقد الأجنبي لدى المصرف ، ما لم يسبق لك الحصول على
                بطاقة .
              </p>
            </div>
          </div>

          <!-- <div class="column">
            <div
              class="flex-card icon-card-hover visa-card light-bordered padding-20"
              @click="makeCardRequest('تفعيل البطاقة',34)"
            >
              <h3 class="card-title has-text-link is-clean">تفعيل البطاقة</h3>
              <p class="card-description">بناء على رغبتك فإنه يمكنك تفعيل بطاقتك.</p>
            </div>
          </div> -->

          <div class="column">
            <div
              class="flex-card icon-card-hover visa-card light-bordered padding-20"
              @click="makeCardRequest('تعطيل البطاقة', 32)"
            >
              <h3 class="card-title has-text-link is-clean">إيقاف البطاقة</h3>
              <p class="card-description">
                بناء على رغبتك فإنه يمكنك إيقاف بطاقتك عن الخدمة أو إلغائها.
              </p>
            </div>
          </div>
        </div>

        <div class="columns is-vcentered s">
          <div class="column is-4">
            <div
              class="flex-card icon-card-hover visa-card light-bordered padding-20"
              @click="makeCardRequest(' إصدار بطاقة بدل فاقد', 26)"
            >
              <h3 class="card-title has-text-link">إصدار بطاقة بدل فاقد</h3>
              <p class="card-description">
                في حال فقدان البطاقة بسبب السرقة أو الضياع أو تلف البطاقة ، فإنه
                يمكنك إصدار بطاقة بديلة عنها ، وبدوركم العمل على زيارة فرعكم
                المصرفي لإستلامها .
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
      >
        <a
          class="button is-dark btn-align modal-dismiss is-bold is-medium"
          @click="$router.go('-1')"
        >
          <b>العودة</b>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";
import moment from "moment";

export default {
  name: "visa",

  data() {
    return {
      customerdate: null,
      customertime: null,
      url: "vs/newRequest",
      requestInfo: {
        ServicAction_Id: null,
        Customer_Id: 1,
        BranchId: null,
      },
    };
  },
  methods: {
    makeRequest(actionstring, action, url) {
      this.$dialog.confirm({
        message: "هل انت متأكد من طلب " + actionstring,
        cancelText: "لا",
        confirmText: "نعم",
        type: "is-success",
        onConfirm: () =>
          this.$router.push({
            name: "servicerequest",
            params: {
              requeststring: actionstring,
              requestid: action,
              requesturl: this.url,
            },
          }),
      });
    },
    makeCardRequest(actionstring, action, url) {
      this.$dialog.confirm({
        message: "هل انت متأكد من طلب " + actionstring,
        cancelText: "لا",
        confirmText: "نعم",
        type: "is-success",
        onConfirm: () =>
          this.$router.push({
            name: "servicerequestwithcard",
            params: {
              requeststring: actionstring,
              requestid: action,
              requesturl: this.url,
            },
          }),
      });
    },
  },
};
</script>
